import { Constants } from "../../constants";
import {
  GET_USER_DATA_SUCCESSFUL,
  LOGIN_FAILED,
  LOGIN_IN_PROGRESS,
  LOGIN_SUCCESSFUL,
  LOGOUT
} from "../action/action-types";

let initialState = {
  inProgress: false,
  successful: false,
  failed: false,
  user: {
    email: null,
    firstName: null,
    lastName: null,
    id: null,
    authRole: null,
    isInApprovalFlow: false,
    canEditPapers: false,
    canSetArticolBugetar: false,
    companyName: "",
    canSeeContracts: false,
    canSeeApprovedPapers: false,
    canSeeAllPapers: false,
    canSetPaperAsPrinted: false,
  },
  errors: {},
  redirectToLogin: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_SUCCESSFUL:
    case GET_USER_DATA_SUCCESSFUL:
      let user = action.payload;
      let companyName = "";
      if (user.company && user.company.companyDetails) {
        companyName = user.company.companyDetails.name;
      }
      return {
        ...state,
        user: {
          email: user.email,
          firstName: user.firstName,
          lastName: user.lastName,
          id: user.id,
          authRole: user.authRole,
          department: user.department,
          isInApprovalFlow: user.isInApprovalFlow,
          canSeePapersExcelReport: user.canSeePapersExcelReport,
          canEditPapers: user.canEditPapers,
          canSetArticolBugetar: user.canSetArticolBugetar,
          companyName: companyName,
          isDelegated: user.isDelegated,
          canSeeAllReports: user.canSeeAllReports,
          canEditAccountingReports: user.canEditAccountingReports,
          canEditAcquisitionsReports: user.canEditAcquisitionsReports,
          canEditReceptionReports: user.canEditReceptionReports,
          canSeeContracts: user.canSeeContracts,
          canSeeApprovedPapers: user.canSeeApprovedPapers,
          canSeeAllPapers: user.canSeeAllPapers,
          canSetPaperAsPrinted: user.canSetPaperAsPrinted,
        },
        successful: true,
        redirectToLogin: false
      };
    case LOGIN_IN_PROGRESS:
      return { ...state, inProgress: true };
    case LOGIN_FAILED:
      return {
        ...state,
        failed: true,
        errors: action.payload.errors,
        inProgress: false
      };
    case LOGOUT:
      localStorage.removeItem(Constants.STORAGE_JWT_TOKEN_KEY);
      return { ...initialState, redirectToLogin: true, successful: false };
    default:
      return state;
  }
}
